import HeroSlider from "./components/HeroSlider";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedProducts from "./components/FeaturedProducts";
import BlogPreview from "./components/BlogPreview";
import SocialCauseBanner from "./components/SocialCauseBanner";
import FAQSection from "./components/FAQSection";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSlider />
        <CategoriesSection />
        <FeaturedProducts />
        <SocialCauseBanner />
        <BlogPreview />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
